import { render, staticRenderFns } from "./CustomerTypeFilter.vue?vue&type=template&id=42840a5e&"
import script from "./CustomerTypeFilter.vue?vue&type=script&lang=js&"
export * from "./CustomerTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports